import { FC } from "react";
import SimpleCard from "../common/simple-card";
import FlexBox from "../common/flex-box";
import { GBP_SYMBOL } from "lib/constants";
import { formatDate, formatDateUTC, getTotalMonthsFromDates } from "lib/utils/date-utils";
import SimpleTextbox from "../common/simple-textbox";
import useFormBinder from "lib/hooks/useFormBinder";
import { DEFAULT_ROOM_DETAILS } from "lib/constants/default-values";
import { POSITIVE_NUMBER_VALIDATION_SCHEMA } from "lib/constants/validation-constants";
import ClinicRoomsDropdown from "../common/dashboard/clinic-rooms-dropdown";
import { getArrayFrom, getItemFromArray } from "lib/utils/array-utils";

interface RoomBookingSummaryTileProps {
  clinicName?: string;
  practitionerName?: string;
  roomNumber?: number;
  pricePerDay?: number;
  dates: Date[];
  isShowFromDateToDate?: boolean;
  isEditable?: boolean;
  rooms?: RoomDetails[];
}

const RoomBookingSummaryTile: FC<RoomBookingSummaryTileProps> = ({
  clinicName,
  roomNumber,
  practitionerName,
  pricePerDay,
  dates,
  isShowFromDateToDate = false,
  isEditable = false,
  rooms = [],
}) => {
  const fromDate = formatDate(new Date(dates?.[0] ?? Date.now()).toISOString());
  const toDate = formatDate(
    new Date(dates?.[dates?.length - 1] ?? Date.now()).toISOString()
  );
  // const { values, handleChange, setValues } = useFormBinder<RoomDetails>({
  //   ...DEFAULT_ROOM_DETAILS(roomNumber?.toFixed() ?? "0"),
  //   pricePerDay: pricePerDay ?? 0,
  // });

  const totalCost = pricePerDay * dates?.length;

  return (
    <SimpleCard className="rounded">
      <FlexBox justifyContent="center" alignItems="start" direction="column">
        <FlexBox justifyContent="between" alignItems="center">
          <small>Practitioner: </small>
          <small>
            <strong>{practitionerName}</strong>
          </small>
        </FlexBox>
        <FlexBox justifyContent="between" alignItems="center">
          <small>Clinic: </small>
          <small>
            <strong>{clinicName}</strong>
          </small>
        </FlexBox>
        <FlexBox justifyContent="between" alignItems="center">
          <small>Room: </small>
          <small>
            <strong>Room-{roomNumber}</strong>
          </small>
        </FlexBox>
        <FlexBox justifyContent="between" alignItems="center">
          <small>Room Cost: </small>
          <small>
            <strong>
              {GBP_SYMBOL}&nbsp;
              {pricePerDay}
            </strong>
          </small>
        </FlexBox>
        {isShowFromDateToDate && (
          <>
            <FlexBox justifyContent="between" alignItems="center">
              <small>From Date </small>
              <small>
                <strong>{fromDate}</strong>
              </small>
            </FlexBox>
            <FlexBox justifyContent="between" alignItems="center">
              <small>To Date </small>
              <small>
                <strong>{toDate}</strong>
              </small>
            </FlexBox>
          </>
        )}
        <FlexBox justifyContent="between" alignItems="center">
          <small>Total Days </small>
          <small>
            <strong>{dates?.length}</strong>
          </small>
        </FlexBox>
        <FlexBox justifyContent="between" alignItems="center">
          <small>Total Months </small>
          <small>
            <strong>{getTotalMonthsFromDates(dates)}</strong>
          </small>
        </FlexBox>
        <hr />
        <FlexBox justifyContent="between" alignItems="center">
          <small>
            <b>Total Cost: </b>
          </small>
          <small>
            <strong>
              {GBP_SYMBOL}&nbsp;
              {totalCost}
            </strong>
          </small>
        </FlexBox>
      </FlexBox>
    </SimpleCard>
  );
};

export default RoomBookingSummaryTile;
